import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/tutorialAutomaton";
import { useUser } from "../../context/userContext";
import { useDot } from "../../context/automatonContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHistorical";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
// import { Button } from "@material-ui/core";
import MyDropzone from "components/Dropzone/MyDropzone";
import { DialogActions } from "@material-ui/core";
// import { Button } from "@material-ui/core";
// const percent = "100%";
import AutomatoSelector from "../AutomatoSelector/AutomatoSelector";
import automatonConstants from "../../constants/Automaton/automatonInfo";
import importConstants from "constants/Dialogs/ImportConstants/importConstants";

const useStyles = makeStyles(styles);

export default function ImportDotDialog() {
  const { language } = useUser();
  const {
    // setDot,
    isActiveDialogImportDot,
    setActiveDialogImportDot,
    automatonType,
    setAutomatonType,
    // setArrayElements,
  } = useDot();

  //   const [texts, setTexts] = useState([]);
  const [checked, setChecked] = useState(true);
  //   const [spacing] = React.useState(2);
  const classes = useStyles();

  const handleClose = () => {
    setActiveDialogImportDot(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveDialogImportDot}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          {constants.modal.importDot[language]}
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h1 style={{ fontSize: "1.2rem" }}>
              {
                automatonConstants.automatonSelector.automatonSelection[
                  language
                ]
              }
              :
            </h1>

            <AutomatoSelector
              automatonType={automatonType}
              setAutomatonType={setAutomatonType}
            />
            <p>
              {automatonType &&
                automatonConstants.machineTypes[automatonType][language]}
            </p>
          </div>
          <MyDropzone
            open={isActiveDialogImportDot}
            setOpen={setActiveDialogImportDot}
            text={importConstants.importDialog.text[language]}
            selectedType={automatonType}
            textClipboard={importConstants.importDialog.textClipboard[language]}
          />
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
